var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.094,
    height: 20.73,
    viewBox: "0 0 12.094 20.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M16.456,19.446l7.762-7.768a1.461,1.461,0,0,1,2.072,0,1.479,1.479,0,0,1,0,2.078l-8.8,8.8a1.464,1.464,0,0,1-2.023.043L6.615,13.762a1.467,1.467,0,1,1,2.072-2.078Z",
    transform: "translate(-11.353 26.516) rotate(-89)",
    fill: "#111926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.7fb2e5c1c4b0b55e9041f3c57a8d6d77.svg";
export { ForwardRef as ReactComponent };